<template>
  <div class="favourite-aside">
    <ModalAsideHeader>
      {{ messages.title }}
      <span class="favourite-aside__grey">{{ likes.length }}</span>
    </ModalAsideHeader>
    <ModalAsideBody>
      <SmallFavouriteProduct
        v-for="item in likes"
        :key="(item.offer && item.offer.id) || item.id"
        :result="item"
      />
    </ModalAsideBody>
    <ModalAsideBottom>
      <DefButtonPrimary :href="listPage">
        {{ messages.toDetail }}
      </DefButtonPrimary>
    </ModalAsideBottom>
  </div>
</template>

<script lang="ts" setup>
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import { computed } from 'vue';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';
import SmallFavouriteProduct from '@components/Favourite/SmallFavouriteProduct.vue';
import ModalAsideBottom from '@use/useModalAside/ModalAsideBottom.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useFavouriteStore } from '@/storePinia/stores/favourite';
import { storeToRefs } from 'pinia';

const favouriteStore = useFavouriteStore();

const { messages, likes, routes } = storeToRefs(favouriteStore);

const listPage = computed(() => routes?.value?.listPage?.path);
</script>

<style lang="scss" scoped>
.favourite-aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  &__grey {
    color: #5f5f67;
  }
  :deep(.def-button-cross__icon) {
    width: 24px;
    height: 24px;
    fill: #5f5f67;
  }
  :deep(.def-button-primary) {
    width: 100%;
    @include point-md {
      width: unset;
    }
  }
  :deep(.modal-aside-bottom) {
    @include point-md {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
